import { useBoundStore } from "@/app/store";
import { PageLayoutDesktop } from "./PageLayout.desktop";
import { PageLayoutMobile } from "./PageLayout.mobile";
import { NavbarProps } from "./Navbar.mobile";
import { FabMobileProps } from "./Fab.mobile";
import { FabDesktopProps } from "./Fab.desktop";

export type FabProps = FabMobileProps & FabDesktopProps;

export interface PageLayoutProps {
  animationKey?: string;
  children: React.ReactNode;
  className?: string;
  fab?: FabProps;
  navbar?: NavbarProps;
  onScroll?: (event: React.UIEvent<HTMLElement>) => void;
  resizeViewportOnKeyboardOpen?: boolean;
  showBottomNavigation?: boolean;
}

/**
 * Page layout component that handles responsive layout (desktop/mobile) and
 * persistent rendering with configuration from global state.
 *
 * Uses slot architecture: atomic selectors are inside Desktop/Mobile components,
 * so this wrapper never re-renders when layout config changes.
 * Children are passed through without re-rendering when navbar/fab/bottomNav update.
 */
export function PageLayout() {
  // Only subscribe to deviceType - this rarely changes
  const deviceType = useBoundStore((state) => state.device.type);

  // Desktop/Mobile components handle their own atomic selectors internally
  return deviceType === "desktop" ? <PageLayoutDesktop /> : <PageLayoutMobile />;
}
